import {
  createRouter,
  parseSearchWith,
  stringifySearchWith,
} from '@tanstack/react-router';

import { Route as rootRoute } from './routes/__root';
import { Route as acceptInvitationRoute } from './routes/accept-invitation';
import { Route as adminRoute } from './routes/admin';
import { Route as consultingRoute } from './routes/consulting';
import { Route as contactRoute } from './routes/contact';
import { Route as dashboardRoute } from './routes/dashboard';
import { Route as docsRoute } from './routes/docs';
import { Route as faqRoute } from './routes/faq';
import { Route as gettingStartedRoute } from './routes/getting-started';
import { Route as indexRoute } from './routes/index';
import { Route as onboardingRoute } from './routes/onboarding';
import { Route as philosophyRoute } from './routes/philosophy';
import { Route as pricingRoute } from './routes/pricing';
import { Route as privacyRoute } from './routes/privacy';
import { Route as reviewRoute } from './routes/review';
import { Route as signInRoute } from './routes/sign-in';
import { Route as tasksRoute } from './routes/tasks';
import { Route as telemetryRoute } from './routes/telemetry';
import { Route as termsRoute } from './routes/terms';

// Create route tree. /billing and /members were consolidated into /dashboard;
// they were deleted in this commit and now 404.
const routeTree = rootRoute.addChildren([
  indexRoute,
  signInRoute,
  dashboardRoute,
  adminRoute,
  reviewRoute,
  tasksRoute,
  telemetryRoute,
  onboardingRoute,
  acceptInvitationRoute,
  philosophyRoute,
  pricingRoute,
  gettingStartedRoute,
  faqRoute,
  docsRoute,
  termsRoute,
  privacyRoute,
  contactRoute,
  consultingRoute,
]);

// Use plain-string search params instead of TanStack's default JSON serializer,
// which wraps every value in double quotes (?installation_id=140318872 becomes
// ?installation_id=%22140318872%22). That quoting broke the onboarding installation_id
// (worked around by coerceInstallationId) and Clerk's __clerk_ticket on
// /accept-invitation (worked around by dropping validateSearch). All of this app's
// search params are plain strings, so cast on write and read raw on read.
const stringifySearch = stringifySearchWith((value) =>
  value === null || value === undefined ? '' : String(value)
);
const parseSearch = parseSearchWith((value) => value);

// Create router instance
export const router = createRouter({
  routeTree,
  parseSearch,
  stringifySearch,
  defaultPreload: 'intent',
  // Reset scroll to the top on forward navigation (e.g. footer links), restore
  // prior position on back/forward, and still honor hash targets. Without this,
  // TanStack Router keeps the previous page's scroll offset on navigation.
  scrollRestoration: true,
});

// Register router for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
